import { useState, useCallback, useMemo } from 'react';
import { cloneDeep } from 'lodash';

import { TabValidationStatuses } from 'enums';
import { getTabValidationStatus } from 'utils/tabUtils';

type Tabs = {
  title: string;
  status: TabValidationStatuses;
  isDraftValid?: boolean;
  draftValidationFunc?: Function;
}[];

export default function useTabs(defaultTabs: Tabs) {
  const [tabs, setTabs] = useState(defaultTabs);

  const handleFormChange = useCallback((formik: any, tabKey: any) => {
    setTabs((oldTabs) => {
      const newStatus = getTabValidationStatus(formik);
      const newDraftStatus = oldTabs[tabKey].draftValidationFunc?.(formik);

      if (
        newStatus === oldTabs[tabKey].status &&
        newDraftStatus === oldTabs[tabKey].isDraftValid
      )
        return oldTabs;

      const newTabs = cloneDeep(oldTabs);
      newTabs[tabKey].status = newStatus;
      newTabs[tabKey].isDraftValid = newDraftStatus;
      return newTabs;
    });
  }, []);

  const onFormChange = useMemo(() => {
    return tabs.map((tab, index) => (formik: any) =>
      handleFormChange(formik, index),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [tabs, onFormChange] as const;
}
